<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Earning from "./earning";
import TopSelling from "./top-selling.vue";

import simplebar from "simplebar-vue";
import Swal from "sweetalert2";

import { salesAnalyticsDonutChart, ChatData } from "./data";
import axios from "axios";

/**
 * Saas Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    simplebar,
    Layout,
    PageHeader,
    Earning,
    TopSelling
  },
  data() {
    return {
      salesAnalyticsDonutChart: salesAnalyticsDonutChart,
      ChatData: ChatData,
      title: "Avava Calendar",
      items: [
        {
          text: "Dashboard",
          href: true,
        }
      ],
      token: null,
      posts: {
        today: [],
        upcoming: []
      },
      isLoadingGetList: false,
      loadingGetPost: false,
      errorGetPost: [],
      selectedPost: {
        is_editable: false
      },
      showModalDetails: false
    };
  },
  async mounted() {
    this.token = await localStorage.getItem('authToken')
    this.retrievePosts();
  },
  computed: {
    isAdmin(){
      return this.$store.getters['auth/isAdmin']
    }
  },
  methods: {
    retrievePosts(){

      this.isLoadingGetList = true

      axios.get(process.env.VUE_APP_API + '/dashboard', {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.posts = res.data.data;
        console.log(this.posts)
      })
      .catch(err => {
        this.err = err;
      })
      .finally(() => {
        this.isLoadingGetList = false;
      });
    },
    onClickPost(post){
      this.showModalDetails = true
      this.loadingGetPost = true
      this.errorGetPost = []

      this.selectedPost = {
        is_editable: false
      }

      axios.get(process.env.VUE_APP_API + '/post/' + post.id, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.selectedPost = res.data.data;
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.errorGetPost = err.response.data.data;
            }
          }
        }
      })
      .finally(() => {
        this.loadingGetPost = false;
      });
    },
    isAuthUser(){
      if(this.selectedPost){
        if(this.selectedPost.user){
          return this.$store.getters['auth/loggedIn'].id == this.selectedPost.user.id
        }
      }

      return false
    },
    navigateToProfile(){
      this.$router.push({ name: 'Profile' })
    },
    renderFileIcon(attachment){
      let filetype = attachment.name;
      
      if(filetype.includes('png') || filetype.includes('jpg') || filetype.includes('jpeg') || filetype.includes('gif') || filetype.includes('svg')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word') || filetype.includes('doc') || filetype.includes('docx')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel') || filetype.includes('xls') || filetype.includes('xlsx')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint') || filetype.includes('ppt') || filetype.includes('pptx')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    },
    onClickEdit(){
      if(this.selectedPost.is_editable){
        this.$router.push({ name: "Edit Post", params: { id: this.selectedPost.id } });
      } else {
        Swal.fire("Error!", "You are not allowed to edit this Post", "error");
      }
    },
    onClickDelete(){
      Swal.fire({
        title: "Delete Post?",
        text: "You are about to delete selected Post. You will NOT be able to restore it back!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/post/' + this.selectedPost.id, {
            _method: 'DELETE'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Deleted!", 'Post has been removed', "success");
            this.showModalDetails = false
            this.getList();
          })
          .catch(err => {
            if('response' in err){
              if('data' in err.response){
                if('message' in err.response.data){
                  this.list_error_messages = err.response.data.data;
                }
              }
            }
          })
        }
      });
    },
    renderDescription(text){
      /* eslint-disable no-useless-escape */
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      let formattedText = text.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">Click here to open link</a>');
      
      // Replace new lines with <br> tags
      formattedText = formattedText.replace(/\r\n|\n|\r/g, '<br>');
      
      return formattedText;
    },
    renderTableDescription(text){
      /* eslint-disable no-useless-escape */
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      let formattedText = text.replace(urlPattern, ' ');
      
      // Replace new lines with <br> tags
      formattedText = formattedText.replace(/\r\n|\n|\r/g, '<br>');
      
      return formattedText;
    },
    onClickDownloadAttachment(attachment){
      window.open(attachment.download_link, '_blank');
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div class="d-flex">
                  <div class="me-3">
                    <div class="avatar-md">
                      <span class="avatar-title rounded-circle font-size-20">{{$store.getters['auth/loggedIn'].name.charAt(0)}}</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 align-self-center">
                    <div class="text-muted">
                      <p class="mb-2">Welcome to Avava Calendar App</p>
                      <h5 class="mb-1">{{ $store.getters['auth/loggedIn'].name }}</h5>
                      <p class="text-muted mb-0 text-truncate">I'm an <strong><u>{{$store.getters['auth/loggedIn'].role}}</u></strong></p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 align-self-center">&nbsp;</div>

              <div class="col-lg-4 d-none d-lg-block">
                <div class="clearfix mt-4 mt-lg-0">
                  <button type="button" class="btn btn-primary btn-block float-end" @click="navigateToProfile()">
                    <i class="bx bxs-user me-2"></i> Profile
                  </button>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Tasks</h4>

            <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
              <b-tab title="Today" active @click="retrievePosts()">
                <b-card-text>
                  <simplebar style="max-height: 400px">
                    <div class="table-responsive">
                      <table class="table table-nowrap align-mid table-hover mb-0">
                        <tbody v-if="isLoadingGetList">
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr v-if="!isLoadingGetList && posts.today.length < 1">
                            <td>
                              <p class="card-text text-center">
                                <i>--- No data available ---</i>
                              </p>
                            </td>
                          </tr>
                          <tr v-if="!isLoadingGetList && posts.today.length > 0" v-for="(post, index) in posts.today" :key="`today_post_${index}`" class="pointer" @click="onClickPost(post)">
                            <td>
                              <span class="badge me-1 mb-1 bg-success">{{ post.room.name }}</span>
                              <span class="badge me-1 mb-1 bg-info" v-if="post.subject">{{ post.subject.name }}</span>
                              <span class="badge me-1 mb-1 bg-dark" v-if="post.item">{{ post.item.name }}</span>
                              <span class="badge me-1 mb-1 bg-danger" v-if="post.is_announcement">ANNOUNCEMENT</span>

                              <h5 class="text-truncate font-size-14 mt-2 mb-1">
                                <a
                                  href="javascript: void(0);"
                                  class="text-dark"
                                >
                                  {{ post.description.length > 50 ? post.description.substring(0, 50) + '...' : post.description }}
                                </a>
                              </h5>
                              <p class="text-muted mb-0">{{ post.human_date }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </simplebar>
                </b-card-text>
              </b-tab>
              <b-tab title="Upcoming" @click="retrievePosts()">
                <b-card-text>
                  <simplebar style="max-height: 400px">
                    <div class="table-responsive">
                      <table class="table table-nowrap align-mid table-hover mb-0">
                        <tbody v-if="isLoadingGetList">
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br/>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br/>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p class="card-text placeholder-glow">
                                <span class="placeholder col-7"></span> <br/>
                                <span class="placeholder col-3"></span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr v-if="!isLoadingGetList && posts.upcoming.length < 1">
                            <td>
                              <p class="card-text text-center">
                                <i>--- No data available ---</i>
                              </p>
                            </td>
                          </tr>
                          <tr v-if="!isLoadingGetList" v-for="(post, index) in posts.upcoming" :key="`upcoming_post_${index}`" class="pointer" @click="onClickPost(post)">
                            <td>
                              <span class="badge me-1 mb-1 bg-success">{{ post.room.name }}</span>
                              <span class="badge me-1 mb-1 bg-info" v-if="post.subject">{{ post.subject.name }}</span>
                              <span class="badge me-1 mb-1 bg-dark" v-if="post.item">{{ post.item.name }}</span>
                              <span class="badge me-1 mb-1 bg-danger" v-if="post.is_announcement">ANNOUNCEMENT</span>

                              <h5 class="text-truncate font-size-14 mt-2 mb-1">
                                <a
                                  href="javascript: void(0);"
                                  class="text-dark"
                                >
                                  {{ post.description.length > 50 ? post.description.substring(0, 50) + '...' : post.description }}
                                </a>
                              </h5>
                              <p class="text-muted mb-0">{{ post.human_date }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </simplebar>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModalDetails"
      title="Post Details"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
      <div slot="modal-title">
        Post Details
      </div>
      <div class="row">
        <div class="col-12">
          <p class="card-text placeholder-glow" v-if="loadingGetPost">
            <span class="placeholder col-7"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
          </p>
          <div class="alert alert-danger" v-if="errorGetPost.length > 0">
            <ul>
              <li v-for="(error, index) in errorGetPost" :key="`error_${index}`">{{ error }}</li>
            </ul>
          </div>
        </div>

        <div class="row" v-if="!loadingGetPost && errorGetPost.length == 0">
          <div class="col-12">
            <strong>Date :</strong> {{ selectedPost.human_date }}
          </div>
          <div class="col-12" v-if="'year' in selectedPost">
            <span class="badge me-1 bg-primary">{{ selectedPost.year.name }}</span>
            <span class="badge me-1 bg-success">{{ selectedPost.room.name }}</span>
          </div>
          <div class="row mt-4" v-if="'description' in selectedPost">
            <div class="col-12 mt-1">
              <span class="badge me-1 even-larger-badge bg-info" v-if="selectedPost.subject">{{ selectedPost.subject.name }}</span>
              <span class="badge me-1 even-larger-badge bg-dark" v-if="selectedPost.item">{{ selectedPost.item.name }}</span>
              <span class="badge me-1 even-larger-badge bg-danger" v-if="selectedPost.is_announcement">ANNOUNCEMENT</span>
              <h5 class="font-size-14 mt-3" v-html="renderDescription(selectedPost.description)"></h5>
            </div>
            <div class="col-12 mt-3" v-if="selectedPost.attachments.length">
              <div v-for="(attachment, index) in selectedPost.attachments" :key="`attachment_${index}`" class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-truncate">
                    <i :class="renderFileIcon(attachment)"></i> {{ attachment.name.length > 20 ? attachment.name.substring(0, 20) + '...' : attachment.name }}
                    <button type="button" class="btn btn-link btn-sm text-primary" @click="onClickDownloadAttachment(attachment)">Download</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3" v-if="selectedPost.protected_files.length">
              <strong class="font-size-14 mb-2"><i class="bx bx-lock-alt"></i> Protected Files</strong>
              <div v-for="(protected_file, index) in selectedPost.protected_files" :key="`protected_file_${index}`" class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-truncate">
                    <i :class="renderFileIcon(protected_file)"></i> {{ protected_file.name.length > 20 ? protected_file.name.substring(0, 20) + '...' : protected_file.name }}
                    <button type="button" class="btn btn-link btn-sm text-primary" @click="onClickDownloadAttachment(protected_file)">Download</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4" v-if="'user' in selectedPost">
            <div class="col-12 mb-3">
              <strong class="font-size-14">Posted By</strong>
            </div>
            <div class="col-2">
              <div class="avatar-xs">
                <span class="avatar-title rounded-circle">{{selectedPost.user.name.charAt(0)}}</span>
              </div>
            </div>
            <div class="col-10">
              <h5 class="font-size-14 mb-1">
                <div class="text-dark">{{selectedPost.user.name}}</div>
                <div class="text-muted small mt-1" v-if="selectedPost.user.contact_no">{{selectedPost.user.contact_no}}</div>
                <div class="text-muted small mt-1" v-if="!selectedPost.user.contact_no"><i>No contact number</i></div>
              </h5>
            </div>
          </div>
        </div>
        <div class="col-12 row justify-space-between mt-4">
          <div class="col" v-if="selectedPost.is_editable">
            <button type="button" class="btn btn-primary me-2" @click="onClickEdit()">Edit</button>
            <button type="button" class="btn btn-danger" @click="onClickDelete()">Delete</button>
          </div>
          <div class="col me-0 right">
            <button :disabled="loadingGetPost" class="btn btn-light" type="button" @click="showModalDetails = false">Close</button>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
